import InvestorMailboxBanner from './investor-mailbox-banner';

export default InvestorMailboxBanner;
